import { formatMetric } from '../../utils/money';
import DeltaBadge from './DeltaBadge';

const subline = ({ ratio, distinct }) => {
  if (ratio) return `${ratio.numerator} of ${ratio.denominator}`;
  if (distinct) {
    const base = `avg ${distinct.daily_average}/day · peak ${distinct.peak}`;
    return distinct.is_exact === false ? `${base} · approx.` : base;
  }
  return null;
};

const StatCard = ({ metric, icon, className = '' }) => {
  const { label, value, delta_pct: deltaPct, direction, is_improvement: isImprovement } = metric;

  const missing = value === null || value === undefined;
  const detail = subline(metric);

  return (
    <div className={`card mb-0 ${className}`}>
      <div className="card-body">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="mb-1 text-base text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
              {label}
            </p>
            <h4
              className={`text-f-h4 font-semibold ${
                missing
                  ? 'text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor'
                  : 'text-theme-headings dark:text-themedark-headings'
              }`}
            >
              {formatMetric(metric)}
            </h4>
          </div>
          {icon && (
            <span className="btn btn-icon btn-light-primary pointer-events-none shrink-0" aria-hidden="true">
              {icon}
            </span>
          )}
        </div>

        {(!missing || detail) && (
          <div className="mt-3 flex flex-wrap items-center gap-2">
            {!missing && (
              <DeltaBadge deltaPct={deltaPct} direction={direction} isImprovement={isImprovement} />
            )}
            {detail && (
              <span className="text-sm text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
                {detail}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
